import {Directive, ElementRef, HostBinding} from '@angular/core';
import {OverlayProperties} from './overlay/interfaces';
import {Overlay} from './overlay/overlay.service';
import {EventService as OverlayEventService} from './overlay/event.service';

@Directive({
    selector: 'tooltip',
    exportAs: 'tooltip'
})

export class TooltipElementDirective {
    get componentRef() {
        return this.overlay.componentRefs[0];
    }

    get isTooltipDestroyed() {
        return this.componentRef && this.componentRef.hostView.destroyed;
    }

    @HostBinding('style.display') hostDisplay: string;

    constructor(
    	private elementRef: ElementRef, 
    	public overlay: Overlay,
    	private overlayEventService: OverlayEventService) {
    	
        this.hostDisplay = 'none';
    }

    public close() {
        if (!this.componentRef || this.isTooltipDestroyed) {
            return;
        }

        this.overlayEventService.emitChangeEvent({
            type: 'Hide'
        });
    }
}